import logo from "../../Assets/UDAC_Logo.png";
import React, { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Detect scroll to apply background
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">
        {/* Logo */}
        <div className="logo">
          <Link to="/" onClick={() => setOpen(false)}>
            <img src={logo} alt="logo" />
          </Link>
        </div>

        {/* Desktop Menu */}
        <ul className={open ? "nav-links active" : "nav-links"}>
          <li>
            <Link to="/" onClick={() => setOpen(false)}>Home</Link>
          </li>
          <li>
            <Link to="/about" onClick={() => setOpen(false)}>About Us</Link>
          </li>
          
          <li>
            <Link to="/blogs" onClick={() => setOpen(false)}>Blogs</Link>
          </li>
          <li>
            <Link to="/contact" onClick={() => setOpen(false)}>Contact Us</Link>
          </li>
        </ul>

        {/* Hamburger */}
        <div className="menu-icon" onClick={() => setOpen(!open)}>
          {open ? <FaTimes size={24} /> : <FaBars size={24} />}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;